import { AvatarSource } from 'store/types/aiAvatar'
import PreviewAvatarButton from './components/buttons/PreviewAvatarButton'
import ResizeAvatarButton from './components/buttons/ResizeAvatarButton'
import EnhanceAvatarButton from './components/buttons/EnhanceAvatarButton'
import DeleteAvatarButton from './components/buttons/DeleteAvatarButton'

export interface IAvatarPreviewAction {
  key: string
  Component: React.FC
  // Per-action visibility driven by the current avatar source. Enhance is
  // hidden for public presets (only user-provided images can be enhanced);
  // Resize and Delete apply to every source.
  isVisible: (source?: AvatarSource) => boolean
}

export const AVATAR_PREVIEW_ACTIONS: IAvatarPreviewAction[] = [
  { key: 'preview', Component: PreviewAvatarButton, isVisible: () => true },
  { key: 'resize', Component: ResizeAvatarButton, isVisible: () => true },
  {
    key: 'enhance',
    Component: EnhanceAvatarButton,
    isVisible: source =>
      source === AvatarSource.UPLOAD || source === AvatarSource.MY_FILES
  },
  { key: 'delete', Component: DeleteAvatarButton, isVisible: () => true }
]
